<template>
  <ul class="mobile-menu__sub-menu" v-if="isLearningAreasActive">
    <template v-for="area in areas">
      <router-link
        :key="`mobile-cat-${area.id}`"
        :to="{ name: 'learning-area', params: { id: area.id } }"
        class="mobile-menu__sub-link-wrapper"
      >
        <div class="mobile-menu__sub-link">
          {{ area.name }}
          <div class="mobile-menu__sub-link-arrow-wrapper">
            <span class="mobile-menu__sub-link-arrow material-icons"
              >keyboard_arrow_right</span
            >
          </div>
        </div>
      </router-link>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'Categories',
  props: {
    primaryAreas: {
      type: Array,
      required: true,
    },
    secondaryAreas: {
      type: Array,
      required: true,
    },
    isLearningAreasActive: {
      type: Boolean,
      required: true,
    },
    currentCategory: {
      type: String,
      required: true,
    },
  },
  computed: {
    areas() {
      const { primaryAreas, secondaryAreas } = this
      return [...primaryAreas, ...secondaryAreas]
    },
  },
}
</script>

<style lang="scss" scoped>
$mobile: 320px;
$tablet: 769px;
$desktop: 1024px;
$lg_desktop: 1300px;
.mobile-menu {
  $this: &;
  &__sub-menu {
    margin: 0;
    padding: 0;
  }
  &__sub-link-wrapper {
    position: relative;
    color: var(--white);
  }
  &__sub-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 60px;
    border-bottom: 1px solid #222;
    position: relative;
  }
  &__sub-link-active {
    position: absolute;
    width: 8px;
    top: 0;
    left: 0;
    bottom: 0;
    background: var(--orange);
    opacity: 0;
    transition: all 0.2s ease-out;
    &--active {
      opacity: 1;
    }
  }
  &__sub-link-arrow {
    font-size: (20 / 16) * 1rem;
    color: var(--white);
    transform: translateZ(0);
    transition: all 0.2s ease-out;
    &--active {
      transform: rotateZ(180deg);
    }
  }
  &__sub-link-arrow-wrapper {
    padding: 16px 20px;
    border-left: 1px solid #222;
  }
}

.slide-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
